import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";

interface IProps {
    value?: string;
    onSearch: (text: string) => void;
}

const SearchTextbox = ({ value, onSearch }: IProps) => {
    return (
        <div className="search-textbox">
            <input type="text" placeholder="Search..." value={value} onChange={(e) => onSearch(e.currentTarget.value)} maxLength={50} />
            <FontAwesomeIcon icon="search" />
        </div>
    );
};

export default SearchTextbox;
